'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTextLink = undefined;

var _validationConstants = require('../validation/validationConstants');

var isTextLink = exports.isTextLink = function isTextLink(text) {
  return text && text.split('\n').length === 1 && text.match(_validationConstants.URL_REGEX);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/links/linkUtils.js
// module id = 2275
// module chunks = 0